import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTenantNavigation } from '../../hooks/useTenantNavigation';
import { clienteService } from '../../services/api';
import '../../styles/Clientes.css';

const ListaClientes = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const { getTenantPath } = useTenantNavigation();

  useEffect(() => {
    (async () => {
      try {
        // Solicitar más clientes para tener todos disponibles
        const resp = await clienteService.getClientes({ per_page: 200 });
        const body = resp.data || resp;
        setData(body.clientes || []);
      } catch (e) {
        setError(e.response?.data?.error || 'No se pudo cargar la lista');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // Filtrado de clientes por búsqueda
  const clientesFiltrados = data.filter(cliente => {
    const terminoBusqueda = busqueda.toLowerCase().trim();

    if (!terminoBusqueda) return true;

    return (
      cliente.id.toString().includes(terminoBusqueda) ||
      (cliente.nombres && cliente.nombres.toLowerCase().includes(terminoBusqueda)) ||
      (cliente.apellidos && cliente.apellidos.toLowerCase().includes(terminoBusqueda)) ||
      (cliente.cedula && cliente.cedula.includes(terminoBusqueda)) ||
      (cliente.pasaporte && cliente.pasaporte.toLowerCase().includes(terminoBusqueda)) ||
      (cliente.rnc && cliente.rnc.includes(terminoBusqueda)) ||
      (cliente.apodo && cliente.apodo.toLowerCase().includes(terminoBusqueda)) ||
      (cliente.celular && cliente.celular.includes(terminoBusqueda)) ||
      (cliente.direccion && cliente.direccion.toLowerCase().includes(terminoBusqueda)) ||
      // Búsqueda por nombre completo
      (cliente.nombres && cliente.apellidos &&
       `${cliente.nombres} ${cliente.apellidos}`.toLowerCase().includes(terminoBusqueda))
    );
  });

  useEffect(() => {
    (async () => {
      try {
        const resp = await clienteService.getClientes({ per_page: 100 });
        const body = resp.data || resp;
        setData(body.clientes || []);
      } catch (e) {
        setError(e.response?.data?.error || 'No se pudo cargar la lista');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div className="loading">Cargando...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Clientes</h1>
      </div>

      {/* Campo de búsqueda */}
      <div style={{
        marginBottom: '1.5rem',
        padding: '1rem',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem'
        }}>
          <div style={{ flex: 1 }}>
            <input
              type="text"
              placeholder="Buscar por nombre, cédula, apodo, celular, dirección o ID..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              style={{
                width: '100%',
                padding: '0.75rem 1rem',
                fontSize: '1rem',
                border: '2px solid #ddd',
                borderRadius: '8px',
                outline: 'none',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#2196F3'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
            />
          </div>
          {busqueda && (
            <button
              onClick={() => setBusqueda('')}
              style={{
                padding: '0.75rem 1.5rem',
                backgroundColor: '#e74c3c',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem'
              }}
            >
              Limpiar
            </button>
          )}
        </div>
        {busqueda && (
          <div style={{
            marginTop: '0.75rem',
            fontSize: '0.9rem',
            color: '#666',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
            </svg>
            <span>
              <strong>{clientesFiltrados.length}</strong> cliente{clientesFiltrados.length !== 1 ? 's' : ''} encontrado{clientesFiltrados.length !== 1 ? 's' : ''}
              {clientesFiltrados.length !== data.length && ` de ${data.length} total`}
            </span>
          </div>
        )}
      </div>

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Foto</th>
              <th>ID</th>
              <th>Nombre</th>
              <th>Apodo</th>
              <th>Documento</th>
              <th>Celular</th>
              <th>Dirección</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {clientesFiltrados.length === 0 ? (
              <tr>
                <td colSpan="8" style={{
                  textAlign: 'center',
                  padding: '2rem',
                  color: '#666',
                  fontSize: '1rem'
                }}>
                  {busqueda ? (
                    <>
                      <svg width="48" height="48" viewBox="0 0 16 16" fill="currentColor" style={{opacity: 0.3, marginBottom: '1rem'}}>
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                      </svg>
                      <div>No se encontraron clientes que coincidan con "{busqueda}"</div>
                    </>
                  ) : (
                    'No hay clientes registrados'
                  )}
                </td>
              </tr>
            ) : (
              clientesFiltrados.map((c) => (
                <tr key={c.id}>
                  <td>
                    <div style={{ position: 'relative', width: '50px', height: '50px' }}>
                      {c.foto_url && c.foto_url.trim() !== '' ? (
                        <>
                          <img
                            src={c.foto_url}
                            alt={`${c.nombres} ${c.apellidos}`}
                            className="cliente-foto"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.parentElement.querySelector('.cliente-foto-placeholder').style.display = 'flex';
                            }}
                          />
                          <div className="cliente-foto-placeholder" style={{ display: 'none' }}>
                            <span>{c.nombres?.charAt(0) || '?'}{c.apellidos?.charAt(0) || '?'}</span>
                          </div>
                        </>
                      ) : (
                        <div className="cliente-foto-placeholder">
                          <span>{c.nombres?.charAt(0) || '?'}{c.apellidos?.charAt(0) || '?'}</span>
                        </div>
                      )}
                    </div>
                  </td>
                  <td>{c.id}</td>
                  <td>
                    <div style={{ fontWeight: '500' }}>
                      {c.nombres} {c.apellidos}
                    </div>
                  </td>
                  <td>
                    {c.apodo ? (
                      <span style={{
                        color: '#2196F3',
                        fontStyle: 'italic',
                        fontSize: '0.9rem'
                      }}>
                        "{c.apodo}"
                      </span>
                    ) : (
                      <span style={{ color: '#999' }}>-</span>
                    )}
                  </td>
                  <td>
                    {c.cedula ? (
                      <div>
                        <div style={{fontSize: '0.75rem', color: '#666'}}>Cédula</div>
                        <div style={{fontWeight: '500'}}>{c.cedula}</div>
                      </div>
                    ) : c.pasaporte ? (
                      <div>
                        <div style={{fontSize: '0.75rem', color: '#666'}}>🛂 Pasaporte</div>
                        <div style={{fontWeight: '500'}}>{c.pasaporte}</div>
                      </div>
                    ) : c.rnc ? (
                      <div>
                        <div style={{fontSize: '0.75rem', color: '#666'}}>🏢 RNC</div>
                        <div style={{fontWeight: '500'}}>{c.rnc}</div>
                      </div>
                    ) : (
                      <span style={{ color: '#999' }}>-</span>
                    )}
                  </td>
                  <td>{c.celular || '-'}</td>
                  <td style={{
                    maxWidth: '200px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {c.direccion || '-'}
                  </td>
                  <td>
                    <Link to={getTenantPath(`clientes/${c.id}/editar`)} className="btn">Editar</Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListaClientes;
